import Index from '@/views/common/Index'
import Hydw from '@/views/member/manage/company/Hydw'
import Hygr from '@/views/member/manage/person/Hygr'
import Hydwsh from '@/views/member/approve/company/Hydwsh'
import Hygrsh from '@/views/member/approve/person/Hygrsh'
import Hydwrh from '@/views/member/membership/company/Hydwrh'
import Hygrrh from '@/views/member/membership/person/Hygrrh'
import Hydwldsh from '@/views/member/leaderApprove/company/Hydwldsh'
import Hygrldsh from '@/views/member/leaderApprove/person/Hygrldsh'

import Hytzs from '@/views/member/notice/Hytzs'

import Userdw from '@/views/member/user/company/Userdw'
import Usergr from '@/views/member/user/person/Usergr'
import NoticeMb from '@/views/member/notice/HytzsMb.vue'
import Hydwbgsh from '@/views/member/approve/companyBg/Hydwbgsh'
import Hygrbgsh from '@/views/member/approve/personBg/Hygrbgsh'
import Remark from '@/views/personal/remark/Remark'
import HythApply from '@/views/member/exit/apply/Apply'
import HythCheck from '@/views/member/exit/check/Check.vue'

import HyHfMb from '@/views/member/feetemplate/HyhfMb.vue'
export default [{
  path: '/index',
  name: 'index',
  redirect: 'home',
  meta: {
    auth: true
  },
  component: Index,
  children: [
    //-----------单位会员申请---------------
    {
      path: '/member/hydw/hydwApplyWeb',
      meta: {
        auth: true,
        title: "单位会员申请"
      },
      component: Hydw,
      children: [{
        path: '/',
        name: 'member/hydw/hydwApplyWeb',
        meta: {
          keepAlive: false
        },
        component: resolve => require(['@/views/member/manage/company/HydwEdit'], resolve)
      }, {
        path: '/member/hydw/hydwDetailWeb',
        name: 'member/hydw/hydwDetailWeb',
        meta: {
          keepAlive: false
        },
        component: resolve => require(['@/views/member/manage/company/HydwDetail'], resolve)
      }]
    },
    //-----------单位会员信息变更---------------
    {
      path: '/member/hydw/hydwChange',
      meta: {
        auth: true,
        title: "会员信息变更",
        isRedirect: true
      },
      component: Hydw,
      children: [{
          path: '/',
          name: 'member/hydw/hydwChange',
          meta: {
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/company/HydwChangeList'], resolve)
        },
        {
          path: '/member/hydw/hydwChangeAdd',
          name: 'member/hydw/hydwChangeAdd',
          meta: {
            auth: true,
            title: "单位会员变更新增",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/company/hydwChangeAllEdit'], resolve)
        },
        {
          path: '/member/hydw/hydwChangeEdit',
          name: 'member/hydw/hydwChangeEdit',
          meta: {
            auth: true,
            title: "单位会员变更编辑",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/company/hydwChangeAllEdit'], resolve)
        },
        {
          path: '/member/hydw/hydwChangeDetail',
          name: 'member/hydw/hydwChangeDetail',
          meta: {
            auth: true,
            title: "单位会员变更详情",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/company/hydwChangeDetail'], resolve)
        },
      ]
    },
    //-----------个人会员申请---------------
    {
      path: '/member/hygr/hygrApplyWeb',
      meta: {
        auth: true,
        title: "个人会员申请"
      },
      component: Hygr,
      children: [{
        path: '/',
        name: 'member/hygr/hygrApplyWeb',
        meta: {
          keepAlive: false
        },
        component: resolve => require(['@/views/member/manage/person/HygrEdit'], resolve)
      }, {
        path: '/member/hygr/hygrDetailWeb',
        name: 'member/hygr/hygrDetailWeb',
        meta: {
          keepAlive: false
        },
        component: resolve => require(['@/views/member/manage/person/HygrDetail'], resolve)
      }]
    },
    //-----------个人会员信息变更---------------
    {
      path: '/member/hygr/hygrChange',
      meta: {
        auth: true,
        title: "会员信息变更",
        isRedirect: true
      },
      component: Hygr,
      children: [{
          path: '/',
          name: 'member/hygr/hygrChange',
          meta: {
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/person/HygrChangeList'], resolve)
        },
        {
          path: '/member/hygr/hygrChangeAdd',
          name: 'member/hygr/hygrChangeAdd',
          meta: {
            auth: true,
            title: "个人会员变更新增",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/person/hygrChangeAllEdit'], resolve)
        },
        {
          path: '/member/hygr/hygrChangeEdit',
          name: 'member/hygr/hygrChangeEdit',
          meta: {
            auth: true,
            title: "个人会员变更编辑",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/person/hygrChangeAllEdit'], resolve)
        },
        {
          path: '/member/hygr/hygrChangeDetail',
          name: 'member/hygr/hygrChangeDetail',
          meta: {
            auth: true,
            title: "个人会员变更详情",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/person/hygrChangeDetail'], resolve)
        },
      ]
    },
    //-----------单位会员申请 开始---------------
    {
      path: '/member/hydw/list',
      meta: {
        auth: true,
        title: "单位会员申请",
        isRedirect: true
      },
      component: Hydw,
      children: [{
          path: '/',
          name: 'member/hydw/list',
          meta: {
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/company/HydwList'], resolve)
        },
        {
          path: '/member/hydw/hydwEdit',
          name: 'member/hydw/hydwEdit',
          meta: {
            auth: true,
            title: "单位会员信息",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/company/HydwEdit'], resolve)
        },
        {
          path: '/member/hydw/hydwDetail',
          name: 'member/hydw/hydwDetail',
          meta: {
            auth: true,
            title: "单位会员信息",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/company/HydwDetail'], resolve)
        },
        {
          path: '/member/hydw/hydwfee',
          name: 'member/hydw/hydwfee',
          meta: {
            auth: true,
            title: "单位会费管理",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/company/HydwfeeList'], resolve)
        },

      ]
    },
    //-----------单位会员管理 结束---------------
    //-----------个人会员申请 开始---------------
    {
      path: '/member/hygr/list',
      meta: {
        auth: true,
        title: "个人会员申请",
        isRedirect: true
      },
      component: Hygr,
      children: [{
          path: '/',
          name: 'member/hygr/list',
          meta: {
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/person/HygrList'], resolve)
        },
        {
          path: '/member/hygr/hygrEdit',
          name: 'member/hygr/hygrEdit',
          meta: {
            auth: true,
            title: "个人会员信息",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/person/HygrEdit'], resolve)
        },
        {
          path: '/member/hygr/hygrDetail',
          name: 'member/hygr/hygrDetail',
          meta: {
            auth: true,
            title: "个人会员信息",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/person/HygrDetail'], resolve)
        },
        {
          path: '/member/hygr/hygrfee',
          name: 'member/hygr/hygrfee',
          meta: {
            auth: true,
            title: "个人会费管理",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/person/HygrfeeList'], resolve)
        }
      ]
    },
    //-----------个人会员管理 结束---------------
    //-----------单位会员审核--------------------
    {
      path: '/member/hydwsh',
      meta: {
        auth: true,
        title: "单位会员审核",
        isRedirect: true
      },
      component: Hydwsh,
      children: [{
          path: '/',
          name: 'member/hydwsh',
          component: resolve => require(['@/views/member/approve/company/HydwshList'], resolve)
        },
        {
          path: '/member/hydwsh/HydwDetail',
          name: 'member/hydwsh/HydwDetail',
          meta: {
            auth: true,
            title: "单位会员详情",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/company/HydwDetail'], resolve)
        },
        {
          path: '/member/hydwsh/hydwEdit',
          name: 'member/hydwsh/hydwEdit',
          meta: {
            auth: true,
            title: "单位会员编辑",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/company/HydwEdit'], resolve)
        },
        {
          path: '/member/hydwsh/hydwCommit',
          name: 'member/hydwsh/hydwCommit',
          meta: {
            auth: true,
            title: "单位会员送审",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/company/HydwDetail'], resolve)
        },
      ]
    },
    //-----------会员入会办理--------------------
    {
      path: '/member/hydwrh',
      meta: {
        auth: true,
        title: "会员入会办理",
        isRedirect: true
      },
      component: Hydwrh,
      children: [{
          path: '/',
          name: 'member/hydwrh',
          component: resolve => require(['@/views/member/membership/company/HydwrhList'], resolve)
        },
        {
          path: '/member/hydwrh/HydwDetail',
          name: 'member/hydwrh/HydwDetail',
          meta: {
            auth: true,
            title: "单位会员详情",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/company/HydwDetail'], resolve)
        },
      ]
    },
    //-----------会员入会办理--------------------
    {
      path: '/member/hygrrh',
      meta: {
        auth: true,
        title: "会员入会办理",
        isRedirect: true
      },
      component: Hygrrh,
      children: [{
          path: '/',
          name: 'member/hygrrh',
          component: resolve => require(['@/views/member/membership/person/HygrrhList'], resolve)
        },
        {
          path: '/member/hygrrh/HygrDetail',
          name: 'member/hygrrh/HygrDetail',
          meta: {
            auth: true,
            title: "个人会员详情",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/person/HygrDetail'], resolve)
        },
      ]
    },
    //-----------会员申请废止------------------
    //-----------单位--------------
    {
      path: '/member/hydwAbolish',
      meta: {
        auth: true,
        title: "会员申请废止",
        isRedirect: true
      },
      component: Hydw,
      children: [{
          path: '/',
          name: 'member/hydwAbolish',
          component: resolve => require(['@/views/member/manage/company/hydwAbolishList'], resolve)
        },
        {
          path: '/member/hydwAbolish/hydwDetail',
          name: 'member/hydwAbolish/hydwDetail',
          meta: {
            auth: true,
            title: "会员申请废止详情",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/company/HydwDetail'], resolve)
        },
        {
          path: '/member/hydwAbolish/hydwEdit',
          name: 'member/hydwAbolish/hydwEdit',
          meta: {
            auth: true,
            title: "会员申请废止编辑",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/company/HydwEdit'], resolve)
        }
      ]
    },
    //-----------个人--------------
    {
      path: '/member/hygrAbolish',
      meta: {
        auth: true,
        title: "会员申请废止",
        isRedirect: true
      },
      component: Hydw,
      children: [{
          path: '/',
          name: 'member/hygrAbolish',
          component: resolve => require(['@/views/member/manage/person/hygrAbolishList'], resolve)
        },
        {
          path: '/member/hygrAbolish/hygrDetail',
          name: 'member/hygrAbolish/hygrDetail',
          meta: {
            auth: true,
            title: "会员申请废止详情",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/person/HygrDetail'], resolve)
        },
        {
          path: '/member/hygrAbolish/hygrEdit',
          name: 'member/hygrAbolish/hygrEdit',
          meta: {
            auth: true,
            title: "会员申请废止编辑",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/person/HygrEdit'], resolve)
        }
      ]
    },
    //-----------会员申请退回------------------
    //-----------单位--------------
    {
      path: '/member/hydwBack',
      meta: {
        auth: true,
        title: "会员申请退回",
        isRedirect: true
      },
      component: Hydw,
      children: [{
          path: '/',
          name: 'member/hydwBack',
          component: resolve => require(['@/views/member/manage/company/hydwBackList'], resolve)
        },
        {
          path: '/member/hydwBack/hydwDetail',
          name: 'member/hydwBack/hydwDetail',
          meta: {
            auth: true,
            title: "会员申请退回详情",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/company/HydwDetail'], resolve)
        },
        {
          path: '/member/hydwBack/hydwEdit',
          name: 'member/hydwBack/hydwEdit',
          meta: {
            auth: true,
            title: "会员申请退回编辑",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/company/HydwEdit'], resolve)
        }
      ]
    },
    //-----------个人--------------
    {
      path: '/member/hygrBack',
      meta: {
        auth: true,
        title: "会员申请退回",
        isRedirect: true
      },
      component: Hydw,
      children: [{
          path: '/',
          name: 'member/hygrBack',
          component: resolve => require(['@/views/member/manage/person/hygrBackList'], resolve)
        },
        {
          path: '/member/hygrBack/hygrDetail',
          name: 'member/hygrBack/hygrDetail',
          meta: {
            auth: true,
            title: "会员申请退回详情",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/person/HygrDetail'], resolve)
        },
        {
          path: '/member/hygrBack/hygrEdit',
          name: 'member/hygrBack/hygrEdit',
          meta: {
            auth: true,
            title: "会员申请退回编辑",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/person/HygrEdit'], resolve)
        }
      ]
    },

    //-----------会员申请废止------------------
    //-----------入会通知书--------------------
    {
      path: '/member/hytzs',
      meta: {
        auth: true,
        title: "入会通知书编辑",
        isRedirect: false
      },
      component: Hytzs,
      children: [{
        path: '/member/hytzs/hytzsEdit',
        name: 'member/hytzs/hytzsEdit',
        meta: {
          auth: true,
          title: "",
          keepAlive: false
        },
        component: resolve => require(['@/views/member/notice/HytzsEdit'], resolve)
      }, ]
    },
    //-----------个人会员审核--------------------
    {
      path: '/member/hygrsh',
      meta: {
        auth: true,
        title: "个人会员审核",
        isRedirect: true
      },
      component: Hygrsh,
      children: [{
          path: '/',
          name: 'member/hygrsh',
          component: resolve => require(['@/views/member/approve/person/HygrshList'], resolve)
        },
        {
          path: '/member/hygrsh/HygrDetail',
          name: 'member/hygrsh/HygrDetail',
          meta: {
            auth: true,
            title: "个人会员详情",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/person/HygrDetail'], resolve)
        },
        {
          path: '/member/hygrsh/hygrEdit',
          name: 'member/hygrsh/hygrEdit',
          meta: {
            auth: true,
            title: "个人会员编辑",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/person/HygrEdit'], resolve)
        },
        {
          path: '/member/hygrsh/hydwCommit',
          name: 'member/hygrsh/hydwCommit',
          meta: {
            auth: true,
            title: "单位会员送审",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/person/HygrDetail'], resolve)
        },
      ]
    },
    //-----------单位会员领导审批----------------
    {
      path: '/member/hydwsp',
      meta: {
        auth: true,
        title: "单位会员审核",
        isRedirect: true
      },
      component: Hydwldsh,
      children: [{
          path: '/',
          name: 'member/hydwsp',
          component: resolve => require(['@/views/member/leaderApprove/company/HydwldshList'], resolve)
        },
        {
          path: '/member/hydwsp/HydwDetail',
          name: 'member/hydwsp/HydwDetail',
          meta: {
            auth: true,
            title: "单位会员详情",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/company/HydwDetail'], resolve)
        },
        {
          path: '/member/hydwsh/hydwApprove',
          name: 'member/hydwsh/hydwApprove',
          meta: {
            auth: true,
            title: "单位会员审核",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/leaderApprove/company/HydwApprove'], resolve)
        },
      ]
    },

    //-----------个人会员领导审批----------------
    {
      path: '/member/hygrsp',
      meta: {
        auth: true,
        title: "个人会员审核",
        isRedirect: true
      },
      component: Hygrldsh,
      children: [{
          path: '/',
          name: 'member/hygrsp',
          component: resolve => require(['@/views/member/leaderApprove/person/HygrldshList'], resolve)
        },
        {
          path: '/member/hygrsp/HygrDetail',
          name: 'member/hygrsp/HygrDetail',
          meta: {
            auth: true,
            title: "个人会员详情",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/person/HygrDetail'], resolve)
        },
        {
          path: '/member/hygrsp/hygrApprove',
          name: 'member/hygrsp/hygrApprove',
          meta: {
            auth: true,
            title: "个人会员审核",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/leaderApprove/person/HygrApprove'], resolve)
        },

      ]
    },
    //-----------会员账号管理 开始---------------
    {
      path: '/member/userdw',
      meta: {
        auth: true,
        title: "会员账号管理"
      },
      component: Userdw,
      children: [{
        path: '/',
        name: 'member/userdw/list',
        meta: {
          keepAlive: false
        },
        component: resolve => require(['@/views/member/user/company/UserdwList'], resolve)
      }, ]
    },
    //-----------个人用户管理 开始---------------
    {
      path: '/member/usergr',
      meta: {
        auth: true,
        title: "个人用户管理"
      },
      component: Usergr,
      children: [{
        path: '/',
        name: 'member/usergr/list',
        meta: {
          keepAlive: false
        },
        component: resolve => require(['@/views/member/user/person/UsergrList'], resolve)
      }, ]
    },
    //-----------通知书模板管理开始---------------
    {
      path: '/member/hytzsmb',
      meta: {
        auth: true,
        title: "通知书模板管理"
      },
      component: NoticeMb,
      children: [{
        path: '/',
        name: 'member/hytzsmb/list',
        meta: {
          keepAlive: false
        },
        component: resolve => require(['@/views/member/notice/HytzsMbList'], resolve)

      }, ]
    },
    //-----------交费通知模板管理开始---------------
    {
      path: '/member/hyhfmb',
      meta: {
        auth: true,
        title: "交费通知模板管理"
      },
      component: HyHfMb,
      children: [{
        path: '/',
        name: 'member/hyhfmb/list',
        meta: {
          keepAlive: false
        },
        component: resolve => require(['@/views/member/feetemplate/HyhfMbList'], resolve)

      }, ]
    },
    //-----------单位会费管理----------------
    {
      path: '/member/hydwfee',
      meta: {
        auth: true,
        title: "单位会费管理",
        isRedirect: true
      },
      component: Hydw,
      children: [{
          path: '/',
          name: 'member/hydwfee',
          component: resolve => require(['@/views/member/manage/company/HydwfeeList'], resolve)
        },
        {
          path: '/member/hydwfee/HydwDetail',
          name: 'member/hydwfee/HydwDetail',
          meta: {
            auth: true,
            title: "单位会员详情",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/company/HydwDetail'], resolve)
        },
      ]
    },
    //-----------个人会费管理----------------
    {
      path: '/member/hygrfee',
      meta: {
        auth: true,
        title: "个人会费管理",
        isRedirect: true
      },
      component: Hygr,
      children: [{
          path: '/',
          name: 'member/hygrfee',
          component: resolve => require(['@/views/member/manage/person/HygrfeeList'], resolve)
        },
        {
          path: '/member/hygrfee/HygrDetail',
          name: 'member/hygrfee/HygrDetail',
          meta: {
            auth: true,
            title: "个人会员详情",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/person/HygrDetail'], resolve)
        },
      ]
    },
    //-----------单位会员统计----------------
    {
      path: '/member/hydw/hydwtj',
      meta: {
        auth: true,
        title: "单位会员统计",
        isRedirect: true
      },
      component: Hydw,
      children: [{
          path: '/',
          name: 'member/hydwquit',
          component: resolve => require(['@/views/member/manage/company/HydwStatisticsList'], resolve)
        },
        {
          path: '/member/hydwtj/HydwDetail',
          name: 'member/hydwtj/HydwDetail',
          meta: {
            auth: true,
            title: "单位会员详情",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/company/HydwDetail'], resolve)
        },
      ]
    },
    //-----------单位退会管理----------------
    {
      path: '/member/hydwquit',
      meta: {
        auth: true,
        title: "退会管理",
        isRedirect: true
      },
      component: Hydw,
      children: [{
          path: '/',
          name: 'member/hydwquit',
          component: resolve => require(['@/views/member/manage/company/HydwQuitList'], resolve)
        },
        {
          path: '/member/hydwquit/HydwDetail',
          name: 'member/hydwquit/HydwDetail',
          meta: {
            auth: true,
            title: "单位会员详情",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/company/HydwDetail'], resolve)
        },
      ]
    },
    //-----------个人退会管理----------------
    {
      path: '/member/hygrquit',
      meta: {
        auth: true,
        title: "退会管理",
        isRedirect: true
      },
      component: Hygr,
      children: [{
          path: '/',
          name: 'member/hygrquit',
          component: resolve => require(['@/views/member/manage/person/HygrQuitList'], resolve)
        },
        {
          path: '/member/hygrquit/HygrDetail',
          name: 'member/hygrquit/HygrDetail',
          meta: {
            auth: true,
            title: "个人会员详情",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/person/HygrDetail'], resolve)
        },
      ]
    },
    //-----------单位黑名单管理----------------
    {
      path: '/member/hydwblack',
      meta: {
        auth: true,
        title: "黑名单管理",
        isRedirect: true
      },
      component: Hydw,
      children: [{
          path: '/',
          name: 'member/hydwblack',
          component: resolve => require(['@/views/member/manage/company/HydwBlackList'], resolve)
        },
        {
          path: '/member/hydwblack/HydwDetail',
          name: 'member/hydwblack/HydwDetail',
          meta: {
            auth: true,
            title: "单位会员详情",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/company/HydwDetail'], resolve)
        },
      ]
    },
    //-----------个人黑名单管理----------------
    {
      path: '/member/hygrblack',
      meta: {
        auth: true,
        title: "黑名单管理",
        isRedirect: true
      },
      component: Hygr,
      children: [{
          path: '/',
          name: 'member/hygrblack',
          component: resolve => require(['@/views/member/manage/person/HygrBlackList'], resolve)
        },
        {
          path: '/member/hygrblack/HygrDetail',
          name: 'member/hygrblack/HygrDetail',
          meta: {
            auth: true,
            title: "个人会员详情",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/person/HygrDetail'], resolve)
        },
      ]
    },
    //-----------单位会员证书管理----------------
    {
      path: '/member/hydwcertificate',
      meta: {
        auth: true,
        title: "会员管理",
        isRedirect: true
      },
      component: Hydw,
      children: [{
          path: '/',
          name: 'member/hydwcertificate',
          component: resolve => require(['@/views/member/manage/company/HydwCertificateList.vue'], resolve)
        },
        {
          path: '/member/hydwcertificate/HydwDetail',
          name: 'member/hydwcertificate/HydwDetail',
          meta: {
            auth: true,
            title: "单位会员详情",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/company/HydwDetail'], resolve)
        },
        {
          path: '/member/hydwcertificate/hydwEdit',
          name: 'member/hydwcertificate/hydwEdit',
          meta: {
            auth: true,
            title: "单位会员编辑",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/company/HydwEdit'], resolve)
        },
      ]
    },
    //-----------个人会员证书管理----------------
    {
      path: '/member/hygrcertificate',
      meta: {
        auth: true,
        title: "会员管理",
        isRedirect: true
      },
      component: Hygr,
      children: [{
          path: '/',
          name: 'member/hygrcertificate',
          component: resolve => require(['@/views/member/manage/person/HygrCertificateList.vue'], resolve)
        },
        {
          path: '/member/hygrcertificate/HygrDetail',
          name: 'member/hygrcertificate/HygrDetail',
          meta: {
            auth: true,
            title: "个人会员详情",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/person/HygrDetail'], resolve)
        },
        {
          path: '/member/hygrcertificate/hygrEdit',
          name: 'member/hygrcertificate/hygrEdit',
          meta: {
            auth: true,
            title: "个人会员编辑",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/person/HygrEdit'], resolve)
        },
      ]
    },
    //单位会员变更审批
    {
      path: '/member/hydwbgsh',
      meta: {
        auth: true,
        title: "单位会员变更",
        isRedirect: true
      },
      component: Hydwbgsh,
      children: [{
          path: '/',
          name: 'member/hydwbgsh',
          component: resolve => require(['@/views/member/approve/companyBg/HydwbgshList'], resolve)
        },
        {
          path: '/member/hydwbgsh/hydwChangeDetail',
          name: 'member/hydwbgsh/hydwChangeDetail',
          meta: {
            auth: true,
            title: "单位会员变更审核",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/company/hydwChangeDetail'], resolve)
        },
      ]
    },
    //个人会员变更审批
    {
      path: '/member/hygrbgsh',
      meta: {
        auth: true,
        title: "个人会员变更",
        isRedirect: true
      },
      component: Hygrbgsh,
      children: [{
          path: '/',
          name: 'member/hygrbgsh',
          component: resolve => require(['@/views/member/approve/personBg/HygrbgshList'], resolve)
        },
        {
          path: '/member/hygrbgsh/hygrChangeDetail',
          name: 'member/hygrbgsh/hygrChangeDetail',
          meta: {
            auth: true,
            title: "个人会员变更审核",
            keepAlive: false
          },
          component: resolve => require(['@/views/member/manage/person/hygrChangeDetail'], resolve)
        },

      ]
    },
    //批语管理
    {
      path: '/member/personal/remark',
      meta: {
        auth: true,
        title: "批语管理",
        isRedirect: true
      },
      component: Remark,
      children: [{
        path: '/',
        name: 'member/personal/remark',
        component: resolve => require(['@/views/personal/remark/RemarkList'], resolve)
      }]
    },
    //单位会员退会
    {
      path: '/member/hydw/exitApply',
      meta: {
        auth: true,
        title: "退会申请",
        isRedirect: true
      },
      component: HythApply,
      children: [{
        path: '/',
        name: 'member/hydw/exitApply',
        component: resolve => require(['@/views/member/exit/apply/ApplyEdit'], resolve)
      }]
    },
    //个人会员退会
    {
      path: '/member/hygr/exitApply',
      meta: {
        auth: true,
        title: "退会申请",
        isRedirect: true
      },
      component: HythApply,
      children: [{
        path: '/',
        name: 'member/hygr/exitApply',
        component: resolve => require(['@/views/member/exit/apply/ApplyEdit'], resolve)
      }]
    },
    //退回审核
    {
      path: '/member/hyth/exitCheck',
      meta: {
        auth: true,
        title: "退会申请审核",
        isRedirect: true
      },
      component: HythCheck,
      children: [{
        path: '/',
        name: 'member/hygr/exitCheck',
        component: resolve => require(['@/views/member/exit/check/CheckList'], resolve)
      }]
    },
  ]
}]



// WEBPACK FOOTER //
// ./src/router/member.js